import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteBanner } from "./deleteBanner.request";
import { DeleteBannerResponse } from "./deleteBanner.types";

const useDeleteBanner = (
  options?: MutationOptions<DeleteBannerResponse, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestDeleteBanner,
    ...options
  });
};

export default useDeleteBanner;
